import { render } from "./KelompokAccount.vue?vue&type=template&id=e40ebadc"
import script from "./KelompokAccount.vue?vue&type=script&lang=js"
export * from "./KelompokAccount.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__